import React, { useMemo } from "react";
import { Text } from "../text/Text";
import { style as errorStyle } from "./Error.style";
const Error = ({ error, level = 2, style: customStyle }) => {
    const style = useMemo(() => errorStyle(), []);
    return (React.createElement(Text, { level: level, style: [style.error, customStyle], variant: "detail" }, error));
};
export { Error };
